import { useCallback, useState } from 'react';
import { unstable_batchedUpdates as batchedUpdates } from 'react-dom';
import { PaginationProps } from 'antd';
import useCrud from 'hooks/useCrud';
import {
  fetchMarketingPolicy,
  fetchMarketingPolicyList,
  createMarketingPolicy,
  updateMarketingPolicy,
  deleteMarketingPolicy,
} from 'services/api/oms';

type FetchMarketingPolicyListParams = Parameters<typeof fetchMarketingPolicyList>[0];

const defaultPage: PaginationProps = {
  current: 1,
  pageSize: 10,
};

const read = (id: number) =>
  fetchMarketingPolicy(id).then((res) => {
    return res.policy;
  });

function usePolicy() {
  const [page, setPage] = useState<PaginationProps>(defaultPage);
  const [roundId, setRoundId] = useState<number>();
  const [orderBy, setOrderBy] = useState<FetchMarketingPolicyListParams['orderBy']>('priorityAsc');

  const readList = useCallback((params: FetchMarketingPolicyListParams) => {
    const { roundId, orderBy } = params;

    return fetchMarketingPolicyList(params).then((res) => {
      const {
        pages: { pageNum: current, pageSize, totalRows: total },
        policy,
      } = res;

      batchedUpdates(() => {
        setPage({
          current,
          pageSize,
          total,
        });
        setRoundId(roundId);
        setOrderBy(orderBy);
      });

      return policy;
    });
  }, []);

  const crud = useCrud({
    read,
    readList,
    create: createMarketingPolicy,
    update: updateMarketingPolicy,
    del: deleteMarketingPolicy,
  });

  return {
    page,
    roundId,
    orderBy,
    setPage,
    setRoundId,
    setOrderBy,
    ...crud,
  };
}

export default usePolicy;
